import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Blog from "../pages/blog/page";
import LegalServices from "../pages/legal-services/page";
import Library from "../pages/library/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/legal-services",
    element: <LegalServices />,
  },
  {
    path: "/library",
    element: <Library />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
